import * as React from "react";
import { Input, Radio } from "antd";
import "./style/style.scss";
import { observer, inject } from "mobx-react";
import { action } from "pc@action/index";

const RadioGroup = Radio.Group;

const TYPEMAP = {
  name: {
    info: "名字",
    error: "名字不能为空, 最长不可以超出15个字符"
  },
  mobile: {
    info: "手机",
    error: "请输入正确的手机号"
  },
  email: {
    info: "邮箱",
    error: "请输入正确的邮箱"
  },
  gender: {
    info: "性别"
  },
  company: {
    info: "单位",
    error: "单位信息不能为空"
  },
  position: {
    info: "职位",
    error: "职位信息不能为空"
  },
  password: {
    info: "密码",
    error: "密码不能为空"
  },
  invitationcode: {
    info: "邀请码",
    error: "邀请码不能为空"
  }
};

@inject("store")
@observer
export default class PublicVerificationContainer extends React.Component<any, any> {
  public onUserInputInfo = (e: any) => {
    action.onUserInputInfo(e.target.value, e.target.id);
  };

  public onFocusInput = (e: any) => {
    action.onFocusInput(e.target.id);
  };

  public onChangeRadio = (e: any) => {
    action.onChangeRadio(e.target.value);
  };

  public render() {
    const { userInputValues, inputWatcherInfoType } = this.props.store;
    return (
      <div className="user__input--container">
        {inputWatcherInfoType.map((e: any, i: number) => {
          const _type = e === "password" ? "password" : "text";
          return (
            <div key={i} className="user__input--items">
              <span className="user__input-layout">{TYPEMAP[e].info}: </span>
              {e === "gender" ? (
                <RadioGroup onChange={this.onChangeRadio} value={userInputValues[e]}>
                  <Radio value="man">男</Radio>
                  <Radio value="woman">女</Radio>
                </RadioGroup>
              ) : (
                <div className="class__group-items">
                  <Input
                    id={e}
                    type={_type}
                    onFocus={this.onFocusInput}
                    onChange={this.onUserInputInfo}
                    value={userInputValues[e]}
                  />
                  <p>{TYPEMAP[e].error}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/verify/index.tsx